import { createReducer, on } from '@ngrx/store';
import { MailTemplateSendModel } from '../../../models/mail/mail-template-send.model';
import { MailTemplateModel } from '../../../models/mail/mail-template.model';
import { PreviewMailModel } from '../../../models/mail/preview-mail.model';
import { User } from '../../../models/vet-users/user.model';
import { CommunicationLogDto } from '../../models/communication-log.model';
import { SentMailLogModel } from '../../models/sent-mail-log.model';
import * as Actions from './mail.action';
export interface MailState {
  mailMembers: any;
  mailTemplate: MailTemplateModel;
  isSendMail: boolean;
  isChangeReplyToEmailAddress: boolean;
  previewMail: PreviewMailModel;
  emailSaveError: any;
  emailSaveSuccess: boolean;
  communicationLogs: CommunicationLogDto | null;
  communicationsErrorResponse: any;
  sentMailLogs: SentMailLogModel;
  error: any;
  loading: boolean;
}

export const initialState: MailState = {
  mailMembers: null,
  mailTemplate: null,
  isSendMail: false,
  previewMail: null,
  isChangeReplyToEmailAddress: false,
  emailSaveError: null,
  emailSaveSuccess: false,
  communicationLogs: null,
  communicationsErrorResponse: null,
  sentMailLogs: null,
  error: null,
  loading: false
};

export const mailReducer = createReducer(
  initialState,
  on(Actions.loadSentMailLogs, state => ({
    ...state,
    sentMailLogs: null,
    loading: true
  })),
  on(Actions.loadSentMailLogsSuccess, (state, { sentMailLogs }) => ({
    ...state,
    sentMailLogs,
    loading: false
  })),
  on(Actions.loadSentMailLogsFailure, (state, { err }) => ({
    ...state,
    error: err,
    loading: false
  })),
  on(Actions.GetMailMemberTemplates, (state) => {
    return {
      ...state,
      mailMembers: null,
    };
  }),
  on(Actions.GetMailMemberTemplatesSuccess, (state, { model }): MailState => {
    return { ...state, mailMembers: model };
  }),
  on(Actions.GetMailTemplate, (state) => {
    return {
      ...state,
      mailTemplate: null,
    };
  }),
  on(Actions.GetMailTemplateSuccess, (state, { model }): MailState => {
    return { ...state, mailTemplate: model };
  }),
  on(Actions.GetCommunicationLogs, (state) => {
    return {
      ...state,
      communicationLogs: null,
      communicationsErrorResponse: null
    };
  }),
  on(Actions.GetCommunicationLogsSuccess, (state, { model }): MailState => {
    return { ...state, communicationLogs: model };
  }),
  on(Actions.GetCommunicationLogsFailure, (state, { err }): MailState => {
    return { ...state, communicationsErrorResponse: err };
  }),
  on(Actions.SendMail, (state) => {
    return {
      ...state,
      isSendMail: false,
    };
  }),
  on(Actions.SendMailSuccess, (state, { response }): MailState => {
    return { ...state, isSendMail: response };
  }),
  on(Actions.PreviewMail, (state) => {
    return {
      ...state,
      previewMail: null,
    };
  }),
  on(Actions.PreviewMailSuccess, (state, { response }): MailState => {
    console.log(response);
    return { ...state, previewMail: response };
  }),
  on(Actions.SaveMailTemplate, (state) => {
    return {
      ...state,
      mailMembers: { ...state.mailMembers },
    };
  }),
  on(Actions.SaveMailTemplateSuccess, (state, { response }): MailState => {
    return {
      ...state,
      mailMembers: { ...state.mailMembers, templates: response },
    };
  }),
  on(Actions.DeleteMailMemberTemplates, (state, { index }): MailState => {
    if (state.mailMembers && state.mailMembers.members) {
      const members = [...state.mailMembers.members];
      members.splice(index, 1);
      return {
        ...state,
        mailMembers: { ...state.mailMembers, members: members },
      };
    }
    return state;
  }),
  on(Actions.SaveReplyToEMailAddresssSuccess, (state, { response }): MailState => {
    return { ...state, emailSaveSuccess: response };
  }),
  on(Actions.SaveReplyToEMailAddressFailure, (state, { err }): MailState => {
    return {
      ...state,
      emailSaveError: err
    };
  }),
);
